// Library
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class EdlpService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  public getEDLPInitialData() {
    return this.networkService.getRequest(this.configService.getEDLPInitialDataUrl());
  }

  public getEDLPConfig() {
    return this.networkService.getRequest(this.configService.getEDLPConfigUrl());
  }

  public getEDLPEligibleAccounts() {
    return this.networkService.getRequest(this.configService.getEDLPEligibleAccountsUrl());
  }

  public getEDLPPricingData(accountNumber: number) {
    return this.networkService.getRequest(this.configService.getEDLPPricingDataUrl(accountNumber));
  }

  public getEDLPLastRefreshDate() {
    return this.networkService.getRequest(this.configService.getEDLPLastRefreshDateUrl());
  }

  public exportEDLPExcel(filter: any) {
    return this.networkService.postRequest(this.configService.getEDLPExportExcelUrl(), filter);
  }

  public getEDLPSubscriptionStatus(soldTo: number) {
    return this.networkService.getRequest(this.configService.getEDLPSubscriptionStatusUrl() + '?soldTo=' + soldTo);
  }

  public updateEDLPSubscription(soldTo: number) {
    return this.networkService.postRequest(this.configService.getEDLPUpdateSubscriptionUrl(), soldTo);
  }
}
